import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const changeRequestFields = `
id
changeRequestUniqueId
changeRequestService {
  id
  serviceUniqueId
  serviceName
}
changeRequestDescription
changeRequestReviwed
changeRequestChanges {
  id
  serviceChangeUniqueId
  servicePart
  serviceChanges
}
changeRequestDecision {
  id
  serviceChangeApprovalUniqueId
  serviceChangeApprovalDecision
  serviceChangeApprovalComments
  serviceChangeApprovalBy {
            id
            profileUniqueId
            userFirstName
            userLastName
            userEmail
            profilePhone
            profileTitle
            profilePhoto
            profileIsActive
            profileType
          }
}
`


export const CREATE_SERVICE_CHANGE_REQUEST = gql`
  mutation ServiceChangesRequestMutation($input: ChangeRequestInputObject) {
    serviceChangesRequestMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${changeRequestFields}
      }
    }
  }
`


export const GET_SERVICE_CHANGE_REQUEST = gql`
  query GetInstitutionServiceChangesRequest($serviceUniqueId: String!) {
    getInstitutionServiceChangesRequest(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${changeRequestFields}
      }
    }
  }
`

export const GET_POPSM_SERVICE_CHANGE_REQUESTS = gql`
  query GetServiceChangesRequest($filtering: ServiceChangeRequestFilterInputObject) {
    getServiceChangesRequest(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${changeRequestFields}
      }
    }
  }
`

export const POPSM_SERVICE_CHANGES_APPROVAL = gql`
  mutation ServiceChangesApprovalMutation($input: ServiceChangesApprovalInputObject) {
    serviceChangesApprovalMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        id
        serviceChangeApprovalUniqueId
        serviceChangeApprovalDecision
        serviceChangeApprovalComments
        serviceChangeApprovalBy {
          id
          profileUniqueId
          userFirstName
          userLastName
          userEmail
          profileType
        }
      }
    }
  }
`

export const reviewServiceChangesRequestMutation = gql`
  mutation ReviewServiceChangesRequestMutation($input: ChangeRequestInputObject) {
    reviewServiceChangesRequestMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${changeRequestFields}
      }
    }
  }`

